import React from 'react';
import { BaseGalleryItemDropdown } from './BaseGalleryItemDropdown';
import { useGalleryItemDropdown } from './useGalleryItemDropdown';
import { useMotionStudioStatus } from './useMotionStudioStatus';

export const GalleryItemDropdown = ({ onSelectMedia, options, ...rest }) => {
    const { eventsLocationPrefix } = rest;
    const { onClick } = useGalleryItemDropdown({ eventsLocationPrefix, onSelectMedia });
    const { isMotionStudioEnabled, isWochitAccessTokenInvalid } = useMotionStudioStatus();
    const optionsConditionData = { isMotionStudioEnabled, isWochitAccessTokenInvalid };

    return (
        <BaseGalleryItemDropdown
            onClick={onClick}
            options={options}
            optionsConditionData={optionsConditionData}
            {...rest}
        />
    );
};
